import { InjectionToken } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { TravelStatusUpdateModel } from '../models/complex/travel-status-update.model';

/**
 * Public contract of the travel-status-update service: submitting a notification's next travel
 * status, and the early-travel rule the submit dialog checks before it offers the button.
 *
 * Implemented by both the legacy `TravelStatusUpdateService` (which orchestrates the other legacy
 * services directly) and the NgRx-backed `TravelStatusUpdateNgrxService`; consumers depend on this
 * interface via {@link TravelStatusUpdateInstanceToken} rather than on a concrete class.
 */
export interface TravelStatusUpdateInterface {
    /**
     * Configured number of hours before the planned start at which a TRAV/OSR may still be
     * submitted. Zero or less means no limit.
     */
    readonly earlyTravelHoursAllowed: number;

    submitStatus(travelStatusModel: TravelStatusUpdateModel): Observable<TravelStatusUpdateModel>;

    checkForEarlyTravelRuleViolation(plannedStart: moment.Moment, actualDate: moment.Moment): boolean;
}

/**
 * DI token for {@link TravelStatusUpdateInterface}. Lets the app choose which implementation to
 * provide (legacy `TravelStatusUpdateService` or the NgRx-based `TravelStatusUpdateNgrxService`)
 * without consumers depending on a concrete class.
 */
export const TravelStatusUpdateInstanceToken = new InjectionToken<TravelStatusUpdateInterface>(
    'TravelStatusUpdateInterface',
);
